import {profile_menu_expand} from "./profile_menu_expand/profile_menu_expand";
import {profile_menu_info} from "./profile_info_menu/profile_menu_info";
import {remove_err_in_url} from "./error_handling/error_handling";
import {tabs} from "./tabs/tabs";
import {show_front_expert_orders} from "./profile_info_menu/show_front_expert_orders";
import {show_expert_profile_menu} from "./profile_info_menu/show_expert_profile_menu";
import {change_expert_profile_photo} from "./profile_info_menu/change_expert_profile_photo";
import {get_projects_of_users} from "./profile_info_menu/get_projects_of_users";
import {set_expert_profile_image} from "./profile_info_menu/set_expert_profile_image";
import {show_edit_expert_modal} from "./profile_info_menu/show_edit_expert_modal";

profile_menu_expand();
profile_menu_info();
remove_err_in_url();
tabs();
show_front_expert_orders();
show_expert_profile_menu();
change_expert_profile_photo();
get_projects_of_users();
set_expert_profile_image();
show_edit_expert_modal();